module.exports = __webpack_public_path__ + "static/styleguide-site@2x-663b23ccc1db4e559a16fb2eb9351767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/styleguide-site@2x.jpg
// module id = 2658
// module chunks = 134932258599989